module.exports = __webpack_public_path__ + "static/media/ai-voices.aa3b48cb.svg";